export default __webpack_public_path__ + "static/media/stacked.7f17d9fc.svg";